import React, { useEffect, useState } from 'react';
import { TrendingDown, Loader2 } from 'lucide-react';
import { suppliersAPI } from '../services/api';

export const LEVEL_STYLE = { out: 'text-red-700 bg-red-50 border-red-200', critical: 'text-red-700 bg-red-50 border-red-200', warning: 'text-amber-700 bg-amber-50 border-amber-200', watch: 'text-yellow-700 bg-yellow-50 border-yellow-200', ok: 'text-green-700 bg-green-50 border-green-200', none: 'text-gray-600 bg-gray-50 border-gray-200' };
const fmt = (iso) => new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });

// Short label for the admin list: "Rupture ~12 j"
export const forecastLabel = (f) => {
  if (!f) return null;
  if (f.level === 'out') return 'En rupture';
  if (f.stockout_days == null) return null;
  return f.stockout_days === 0 ? 'Rupture imminente' : `Rupture ~${f.stockout_days} j`;
};

// Admin product form: estimated stock-out date from the recent sales pace
const StockForecast = ({ productId, stock }) => {
  const [f, setF] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!productId) return;
    suppliersAPI.stockForecast(productId).then(setF).catch(() => setError(true));
  }, [productId]);

  if (!productId) return null;
  if (error) return null;
  if (!f) return <p className="mt-1 text-xs text-gray-400 flex items-center gap-1"><Loader2 size={11} className="animate-spin" /> Prévision…</p>;

  const liveStock = Math.max(0, parseInt(stock, 10) || 0);
  const liveDays = f.daily_rate > 0 ? Math.floor(liveStock / f.daily_rate) : null;
  const liveDate = liveDays != null ? new Date(Date.now() + liveDays * 86400000) : null;
  const level = liveStock <= 0 ? 'out' : liveDays == null ? 'none' : liveDays <= 7 ? 'critical' : liveDays <= 14 ? 'warning' : liveDays <= 30 ? 'watch' : 'ok';

  return (
    <div className={`mt-2 rounded-md border px-3 py-2 text-xs ${LEVEL_STYLE[level]}`} data-testid="product-stock-forecast">
      <div className="flex items-center gap-1.5 font-semibold"><TrendingDown size={13} />
        {liveStock <= 0 ? 'Produit en rupture' : liveDays == null ? 'Aucune vente sur 90 jours — pas de rupture prévisible' : liveDays === 0 ? 'Rupture imminente (moins d\'un jour de stock)' : `Rupture estimée le ${liveDate.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' })} (dans ${liveDays} j)`}
      </div>
      <div className="mt-0.5 text-[11px] opacity-90">
        Ventes : {f.sales_30d} u. / 30 j · {f.sales_90d} u. / 90 j{f.daily_rate > 0 ? ` · rythme ${f.daily_rate} u./jour${f.basis_days === 90 ? ' (base 90 j)' : ''}` : ''}
        {f.threshold_date && liveStock > f.threshold && f.daily_rate > 0 ? ` · sous le seuil (${f.threshold}) vers le ${fmt(new Date(Date.now() + Math.floor((liveStock - f.threshold) / f.daily_rate) * 86400000).toISOString())}` : ''}
        {f.pending ? ` · +${f.pending} u. attendues (bons en cours)` : ''}
      </div>
    </div>
  );
};

export default StockForecast;
